import type { FieldKey } from '@jira/polaris__domain-field/src/FieldKey.types.tsx';
import { experience } from '@jira/polaris__lib-analytics/src/ConstantsExperience.tsx';
import { createExperienceWithMetaType } from '@jira/polaris__lib-analytics/src/createJpdExperience.tsx';
import { fireCompoundAnalyticsEvent } from '@jira/polaris__lib-analytics/src/fireCompoundAnalyticsEvent.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-sweet-state
import type { StoreActionApi } from '@atlassian/react-sweet-state';
import type { Props, State } from './FieldsUpdate.types.tsx';

const fieldOptionUpdateExperience = createExperienceWithMetaType(
	experience.fieldsSidebar.fieldOptionUpdate,
	'rankOptions',
	(err) => `FieldOptionUpdate: ${err?.message ?? 'generic error'}`,
);

export const rankOptions =
	(fieldKey: FieldKey, rankedOptionIds: string[]) =>
	async (
		{ getState, setState }: StoreActionApi<State>,
		{ onFieldUpdateFailed, projectId, createAnalyticsEvent, fieldRemote }: Props,
	): Promise<void> => {
		const state = getState();
		const previousOptions = state.fields[fieldKey].options;
		if (previousOptions === undefined) {
			return;
		}

		const newOptions = rankedOptionIds
			.map((id) => previousOptions.find((option) => option.jiraOptionId === id))
			.filter(Boolean);

		const fields = {
			...state.fields,
			[fieldKey]: {
				...state.fields[fieldKey],
				options: newOptions,
			},
		};

		setState({ fields });

		if (projectId !== undefined) {
			fieldOptionUpdateExperience.start();

			fieldRemote
				.updateFieldOptionRank({
					fieldKey,
					rankedOptionIds: newOptions.map((option) => option.jiraOptionId),
				})
				.then(() => {
					fieldOptionUpdateExperience.success();

					fireCompoundAnalyticsEvent.FieldConfig.optionRankChanged(createAnalyticsEvent({}), {
						issueFieldKey: fieldKey,
						issueFieldType: fields[fieldKey].type,
					});
				})
				.catch((error: Error) => {
					fieldOptionUpdateExperience.failure(error);

					onFieldUpdateFailed(error);
				});
		}
	};
